import React, { Component } from 'react'
import './styles/Vector.css'

class Vector extends Component {

  constructor(props) {
    super(props)
    this.state = {
      color: "rgba(255, 255, 255, .1)",
      font: "lato",
      isUnknown: !this.props.distance || !this.props.bearing
    }
  }

  componentDidUpdate() {
    var opts = {
      color: this.state.color,
      font: this.state.font,
      isUnknown: this.state.isUnknown,
      text: this.props.distance ? Math.round(this.props.distance) : "?"
    }
    this.updateCanvas(opts)
  }

  componentWillReceiveProps(newProps) {
    if(this.props.distance !== newProps.distance ||
      this.props.bearing !== newProps.bearing)
      {
        this.setState({
          isUnknown: !newProps.distance || !newProps.bearing
        })
      }
  }

  render() {
    const rotateStyle = this.props.bearing ? {
      transform: "rotate(" + this.props.bearing + "deg)"
    } : {}
    return (
      <div
        className="vector"
        ref={elem => this.resetColor(elem)}
      >
        <canvas
          ref="vectorDial"
          className="vectorDial"
          width={512}
          height={512}
          style={rotateStyle}
        ></canvas>
        <canvas
          ref="vectorText"
          className="vectorText"
          width={512}
          height={512}
        ></canvas>
      </div>
    )
  }

  resetColor(elem) {
    if(elem) {
      var newColor = window.getComputedStyle(elem).getPropertyValue("color")
      var newFont = window.getComputedStyle(elem).getPropertyValue("font-family")
      if(this.state.color !== newColor || this.state.font !== newFont) {
        this.setState({
          color: newColor,
          font: newFont
        })
      }
    }
  }

  updateCanvas(opts) {
    opts = Object.assign({
      color: "rgba(255, 255, 255, 0.1)",
      font: "lato",
      isUnknown: true,
      text: "?",

    }, opts)
    const ctx = this.refs.vectorDial.getContext("2d")
    ctx.clearRect(0, 0, 512, 512)
    ctx.lineWidth = 24
    ctx.lineCap = "round"
    ctx.strokeStyle = opts.color
    ctx.fillStyle = opts.color
    ctx.globalAlpha = .2
    if(opts.isUnknown) {
      ctx.beginPath()
      ctx.arc(256, 256, 244, 0, 2 * Math.PI)
      ctx.stroke()
    } else {
      ctx.beginPath()
      ctx.arc(256, 256, 244, (2 * Math.PI) * (56/72), (2 * Math.PI) * (52/72))
      ctx.stroke()
      ctx.globalAlpha = 1
      ctx.beginPath()
      ctx.moveTo(224, 55.4256)
      ctx.lineTo(256, 0)
      ctx.lineTo(288, 55.4256)
      ctx.closePath()
      ctx.fill()
    }

    const ctx2 = this.refs.vectorText.getContext("2d")
    ctx2.clearRect(0, 0, 512, 512)
    ctx2.strokeStyle = opts.color
    ctx2.fillStyle = opts.color
    ctx2.font="200px " + opts.font
    ctx2.textAlign = "center"
    ctx2.textBaseline = "alphabetic"
    ctx2.fillText(opts.text, 256, 281)
    ctx2.font="100px " + opts.font
    ctx2.textBaseline = "hanging"
    ctx2.fillText("SM", 256, 281)
  }
}

export default Vector



// WEBPACK FOOTER //
// ./src/components/Vector.js